import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PurchaseOrderServices from "../../services/purchaseOrder.service";
import { NotificationManager } from "react-notifications";
import AdminManageLanguageService from "../../services/admin-manageLanguage.service";
import { Button, Input, Modal, Select, Spin, Table, Tooltip } from "antd";
import Filter_icon from "../../assets/images/filter_icon.png";
import SearchJewelryDataService from "../../services/search-jewelry.service";
const { Option } = Select;

const myWatchData = {
  vendor: "",
  status: "",
};

export const PurchaseOrder = (props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [purchaseOrders, SetPurchaseOrder] = useState([]);
  const [dealerID, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [vendorType, setVendorType] = useState("");
  const [generateOrderModalVisible, setgenerateOrderModalVisible] =
    useState(false);
  const [cancelOrederData, setCancelOrederData] = useState({
    orderID: "",
    poName: "",
    status: 0,
  });
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [reorderData, setReorderData] = useState({
    PoName: "",
    notes: "",
    referenceNumber: "",
  });
  const [purchaseOrdersProductDetails, SetPurchaseOrderProductDetails] =
    useState([]);
  const [purchaseOrdersDtRetailer, SetPurchaseOrderDtRetailer] = useState([]);
  const [purchaseOrdersDtVendor, SetPurchaseOrderDtVendor] = useState([]);
  const [purchaseOrdersProductPrice, SetPurchaseOrderProductPrice] = useState(
    {}
  );
  const [historyLoading, setHistoryLoading] = useState(false);
  const [validation, setValidations] = useState({
    PONameVal: "",
    notesVal: "",
  });
  const [scaList, setScaList] = useState([]);
  const [selectedSCA, setSelectedSCA] = useState("");
  const [accNo, setAccNo] = useState("");
  const [error, setError] = useState(false);
  const [listerr, setListerr] = useState(false);
  const [cancelOrderVisible, setCancelOrderVisible] = useState(true);
  const [isCancelOrderDisabled, setIsCancelOrderDisabled] = useState(false);
  const [currencySign, setCurrencySign] = useState("");
  const { Search } = Input;
  const [searchValue, SetSearchValue] = useState("");
  const navigate = useNavigate();

  // const filteredData = scaList.filter((item) => item.isVendorapprove);
  // const dataToRender = filteredData.length > 0 ? filteredData : scaList;

  const [hideShowFilter, setHideShowFilter] = useState(false);
  const [vendorsList, setVendorsList] = useState([]);
  const [priceValueChange, setPriceValueChange] = useState(false);
  const [priceValue, setPriceValue] = useState([0, 999999]);
  const [filterWatchValue, setfilterWatchValue] = useState(myWatchData);
  const [selectDrp, setSelectDrp] = useState(null);
  const [filterBtnVisble, setFilterBtnVisble] = useState(true);
  const [state, setState] = useState({ productChange: {} });
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [sortType, setSortType] = useState("asc");
  const [key, setKey] = useState(false);
  const statusMap = {
    0: "Pending",
    1: "Completed",
    2: "Cancelled",
    3: "Open",
    4: "Shipped",
    5: "Unpaid",
  };
  //const filteredData = scaList.filter((item) => item.isVendorapprove);
  //const dataToRender = filteredData.length > 0 ? filteredData : scaList;

  const [statusFilter, setStatusFilter] = useState(null);
  const [vendorFilter, setVendorFilter] = useState(null);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const setFilterStatusorVendors = (vendorId, statusId) => {
    // setVendorFilter("GemFind_Vendor");
    // setVendorFilter("GemFind_Vendor");

    console.log("vendorId: " + vendorId);
    console.log("statusId: " + statusId);

    setVendorFilter(vendorId);
    setStatusFilter(statusId ? Number(statusId) : -1);
  };
  // Apply both filters

  const filteredData = scaList.filter((item) => {
    const isApproved = item.isVendorapprove;
    const matchesStatus =
      statusFilter !== null ? item.status === statusFilter : true;
    const matchesVendor =
      vendorFilter !== null ? item.vendorId === vendorFilter : true;

    console.log(item.vendorId);
    return isApproved && matchesVendor && matchesStatus;
  });
  // const filteredData = scaList.filter((item) => {
  //   const isApproved = item.isVendorapprove;

  //   const matchesStatus =
  //     statusFilter !== null ? item.status === statusFilter : true;

  //   // const matchesVendor =
  //   //   vendorFilter !== null ? item.vendorId === vendorFilter : true;

  //   return isApproved && matchesStatus;
  //   // return isApproved && matchesStatus && matchesVendor;
  // });
  // Fallback if no match
  const dataToRender = filteredData.length > 0 ? filteredData : scaList;

  useEffect(() => {
    setSelectedVendor(filterWatchValue.vendor);
    setSelectedStatus(filterWatchValue.status);
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ==
            "Retailer"
          ) {
            GetMyPurchaseOrderDetails(
              loginDetials.loginDetials.responseData.dealerId,
              "",
              ""
            );
          } else {
            GetMyPurchaseOrderDetails(
              loginDetials.loginDetials.responseData.dealerId,
              loginDetials.loginDetials.responseData.dealerMemberTypeName,
              ""
            );
            setVendorType(
              loginDetials.loginDetials.responseData.dealerMemberTypeName
            );
          }
        }
      }
    }
    handleGetALLJewelryDataListVendorname();
  }, [filterWatchValue.vendor, filterWatchValue.status]);

  const handleCancel = () => {
    setVisible(false);
    setReorderData({
      PoName: "",
      notes: "",
      referenceNumber: "",
    });
    setValidations({
      PONameVal: "",
      notesVal: "",
    });
  };
  const onSearch = (value) => {
    SetSearchValue(value);
    GetMyPurchaseOrderDetails(dealerID, vendorType, value);
  };

  const handleCancel1 = () => {
    setgenerateOrderModalVisible(false);
    setListerr(false);
  };
  const handleOk = () => {
    setgenerateOrderModalVisible(true);
    GetMyPurchaseOrderHistoryDetails(dealerID);
  };
  const handleGetSCAList = async (id) => {
    try {
      await AdminManageLanguageService.getSCADrpdown(id)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setScaList(responseData || []);
            }
          } else {
            setScaList([]);
          }
        })
        .catch((error) => {
          setScaList([]);
        });
    } catch (error) {
      setScaList([]);
    }
  };
  const handleSelectChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setSelectedSCA(e);
    }
  };

  const handleCancelOrder = () => {
    if (cancelOrederData.status === 1) {
      setIsCancelOrderDisabled(true);
    } else {
      setIsCancelOrderDisabled(false);
      if (purchaseOrders.length > 0) {
        setCancelModalVisible(true);
      } else {
        NotificationManager.error(t("No Records Available"));
      }
    }
  };

  const handleHideShowFilter = () => {
    setHideShowFilter(!hideShowFilter);
  };

  const clearSearchFilter = () => {
    setVendorsList([]);
  };

  //Reset Filters
  const resetFilters = () => {
    setfilterWatchValue(myWatchData);
    setSortColumnName("styleNumber");
    setSortType("Asc");
    setKey(!key);
    SetSearchValue("");
    let tempState = filterWatchValue;
    tempState["vendor"] = [];
    tempState["status"] = [];
    setStatusFilter(null);
    clearSearchFilter();
  };

  const applyFilters = () => {
    // setStatusFilter(0);
    setFilterStatusorVendors();

    //   const selectedVendorIds = filterWatchValue.vendor || [];
    //   const selectedVendorNames = vendorsList
    //   .filter(vendor => selectedVendorIds.includes(vendor.vendorNameID))
    //   .map(vendor => vendor.vendorName);

    // // Join names with a comma
    // const vendorNamesString = selectedVendorNames.join(", ");

    // console.log("Selected Vendors:", vendorNamesString);
    //   // setStatusFilter(vendorNamesString.split(","));

    //   const selectedStatusIds = filterWatchValue.status || [];

    // const selectedStatusLabels = selectedStatusIds
    //   .map(id => statusMap[id])
    //   .filter(label => label); // remove undefined

    // const statusLabelsString = selectedStatusLabels.join(", ");
    //   console.log("Selected Vendors:", statusLabelsString);
    //   setStatusFilter("Cancelled");
  };

  const onChangeDrop = (e, name) => {
    setSelectDrp(name);
    setFilterBtnVisble(false);
    let tempState = filterWatchValue;
    tempState[name] = e;
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };

  const onChangeMultiDrop = (e, name) => {
    let isRemove = false;
    if (e.length > filterWatchValue[name].length) {
      isRemove = false;
    } else {
      isRemove = true;
    }
    setSelectDrp(name);
    setFilterBtnVisble(false);
    let tempState = filterWatchValue;
    if (e.includes("")) {
      tempState[name] = [];
      tempState[name].push("");
    } else {
      tempState[name] = e;
    }
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };

  const handleGetALLJewelryDataListVendorname = () => {
    let inputData = {
      orderby: "GFInventoryID",
      order: "ASC",
      category: "",
      vendor: "",
      materialType: "",
      gender: "",
      collection: "",
      collectionID: "",
      materialColor: "",
      minRange: 0,
      maxRange: 0,
      styleNumber: "",
      dealerType: "All",
      noOfRows: 0,
      offset: 0,
      gemstoneType: "",
      strSelectedInvID: "",
      image: "",
    };

    console.log(inputData);

    try {
      SearchJewelryDataService.GetALLJewelryDataListVendornameforjewelrysearch(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var vendorsListData = response.data.responseData.vendors;
          if (message === "Success") {
            console.log("vendorsList");
            console.log(responseData);
            console.log(vendorsListData);
            setVendorsList(vendorsListData); //vendorsList
          } else {
            clearSearchFilter();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
      //setApplyFilterLoading(false);
    }
  };

  const handleCancelModal = () => {
    setCancelModalVisible(false);
  };

  // to create Unique Po Number
  const handleCreatePoNo = () => {
    let inputData = {
      dealerID: dealerID ? dealerID.toString() : "",
    };
    try {
      PurchaseOrderServices.CreatePONumber(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setReorderData({
              PoName: responseData,
            });
          } else {
            setReorderData({
              PoName: "",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          setReorderData({
            PoName: "",
          });
        });
    } catch (error) {
      console.log(error);
      setReorderData({
        PoName: "",
      });
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setReorderData({
        ...reorderData,
        [name]: e,
      });
    } else {
      setReorderData({
        ...reorderData,
        [e.target.name]: e.target.value,
      });

      if (e.target.name == "PoName") {
        setValidations((prevdata) => ({
          ...prevdata,
          PONameVal: "",
        }));
      }
      if (e.target.name == "notes") {
        setValidations((prevdata) => ({
          ...prevdata,
          notesVal: "",
        }));
      }
    }
  };

  const handleValidation = () => {
    const { PoName, notes } = reorderData;

    const validation = {
      PONameVal: "",
      notesVal: "",
    };
    let isValid = true;

    if (!PoName.trim()) {
      isValid = false;
      validation.PONameVal = t("PO Name is Compulsory");
    } else {
      validation.PONameVal = "";
    }

    setValidations(validation);
    return isValid;
  };

  const GetMyPurchaseOrderDetails = (id, vendorType, value) => {
    let inputData = {
      delarId: id,
      type: vendorType ? vendorType : "",
      search: value ? value : "",
    };
    setLoading(true);
    try {
      PurchaseOrderServices.GetMyPurchaseOrder(inputData)
        .then((response) => {
          setLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            SetPurchaseOrder(responseData);
            setCurrencySign(responseData[0].currencySign);
            setCancelOrederData({
              orderID: responseData[0].poid,
              poName: responseData[0].poName,
              status: responseData[0].status,
              currencySign: responseData[0].currencySign,
            });
            if (responseData[0].poid != "") {
              setCancelOrderVisible(false);
            }
            setLoading(false);
          } else {
            SetPurchaseOrder([]);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleUpdateOrderStatus = () => {
    let inputData = {
      dealerID: dealerID.toString(),
      orderID: cancelOrederData.orderID.toString(),
      status: "2",
    };

    try {
      PurchaseOrderServices.UpdateOrderStatus(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setCancelModalVisible(false);
            NotificationManager.success(
              t("Order Has Been Successfully Cancelled.")
            );
            GetMyPurchaseOrderDetails(dealerID, vendorType, "");
          } else {
            setCancelModalVisible(false);
            NotificationManager.error(t("Order Has Not Been Cancelled."));
          }
        })
        .catch((error) => {
          console.log(error);
          setCancelModalVisible(false);
        });
    } catch (error) {
      console.log(error);
      setCancelModalVisible(false);
    }
  };

  const GetMyPurchaseOrderHistoryDetails = (id) => {
    let inputData = {
      dealerID: id,
      orderID: cancelOrederData.orderID,
      pOname: "",
      type: "",
    };
    setHistoryLoading(true);
    try {
      PurchaseOrderServices.purchaseorderhistotry(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            SetPurchaseOrderProductDetails(responseData.productDetail);
            SetPurchaseOrderDtRetailer(responseData.dtRetailer[0]);
            SetPurchaseOrderDtVendor(responseData.dtVendor[0]);
            SetPurchaseOrderProductPrice(responseData.productprice);
            setHistoryLoading(false);
            handleGetSCAList(responseData.purchaseOrder[0].vendorID);
            setAccNo(responseData.purchaseOrder[0].ediAccNumber);
            if (
              responseData.purchaseOrder[0].ediAccNumber == "" ||
              responseData.purchaseOrder[0].ediAccNumber === null
            ) {
              setError(true);
            } else {
              setError(false);
            }
          } else {
            SetPurchaseOrderProductDetails([]);
            SetPurchaseOrderDtRetailer([]);
            SetPurchaseOrderDtVendor([]);
            SetPurchaseOrderProductPrice({});
            setHistoryLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setHistoryLoading(false);
        });
    } catch (error) {
      console.log(error);
      setHistoryLoading(false);
    }
  };

  const handleCreateReOrder = () => {
    var isValid = handleValidation();

    if (!isValid) {
      handleCancel1();
      return false;
    } else if (selectedSCA <= 0) {
      setListerr(true);
      return;
    }

    let inputData = {
      dealerID: dealerID.toString(),
      poid: cancelOrederData.orderID.toString(),
      poName: reorderData.PoName ? reorderData.PoName.toString() : "",
      poNote: reorderData.notes ? reorderData.notes.toString() : "",
      referenceNumber: reorderData.referenceNumber
        ? reorderData.referenceNumber.toString()
        : "",
      scaccode: selectedSCA ? selectedSCA.toString() : "",
    };
    setSubmitLoading(true);
    try {
      PurchaseOrderServices.CreateReOrder(inputData)
        .then((response) => {
          setSubmitLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData == "Please Enter Acc No for this Vendor") {
              NotificationManager.error(
                t("Kindly Add Account Number for this Vendor.")
              );
              setgenerateOrderModalVisible(false);
            } else if (responseData == "Vendor Retailer Not connected") {
              NotificationManager.error(
                t(
                  "Your connection to this vendor is no longer active. Please request access to this vendor again before placing orders. If you believe this is a mistake please contact GemFind support."
                )
              );
              setgenerateOrderModalVisible(false);
            } else {
              NotificationManager.success(
                t("Order Has Been Successfully ReOrder.")
              );
              GetMyPurchaseOrderDetails(dealerID, vendorType, "");
              setgenerateOrderModalVisible(false);
              setVisible(false);
              setSubmitLoading(true);
              handleCancel();
            }
          } else {
            NotificationManager.error(t("Order Has Not Been Cancelled."));
            setSubmitLoading(true);
            handleCancel();
          }
        })
        .catch((error) => {
          console.log(error);
          setSubmitLoading(true);
          handleCancel();
        });
    } catch (error) {
      console.log(error);
      setSubmitLoading(true);
    }
  };

  const RetailerColumns = [
    {
      title: (
        <Tooltip title={t("Purchase Order")}>{t("Purchase Order")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "poName",
      key: "poName",
      render: (item, row) => {
        return (
          <Link
            to={"/purchaseOrderDetails"}
            state={{
              POOrderID: row.poid,
              POOrderName: row.poName,
              currencySign: row.currencySign,
            }}
          >
            {" "}
            <span className="linkText">{row.poName}</span>{" "}
          </Link>
        );
      },
    },
    {
      title: (
        <Tooltip title={t("Reference Number")}>{t("Reference Number")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "referenceNumber",
    },
    {
      title: <Tooltip title={t("Vendor Name")}>{t("Vendor Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "vendorName",
      width: "230px",
    },
    {
      title: <Tooltip title={t("Total items")}>{t("Total items")}</Tooltip>,
      ellipsis: true,
      dataIndex: "variation",
      key: "variation",
    },
    {
      title: <Tooltip title={t("Total Cost")}>{t("Total Cost")}</Tooltip>,
      ellipsis: true,
      dataIndex: "currencyPOTotal",
      render: (item, row) => {
        return <span>{row.currencyPOTotal}</span>;
      },
    },
    {
      title: <Tooltip title={t("Updated")}>{t("Updated")}</Tooltip>,
      ellipsis: true,
      dataIndex: "lastModifiedDate",
      render: (item, row) => {
        return (
          <span> {moment(item.lastModifiedDate).format("MM/DD/yyyy")}</span>
        );
      },
    },
    {
      title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
      ellipsis: true,
      dataIndex: "status",
      render: (item, row) => {
        return item == 2
          ? "Cancelled"
          : item == 1
          ? "Completed"
          : item == 0
          ? "Submited"
          : item == 3
          ? "Open"
          : item == 4
          ? "Shipped"
          : item == 5
          ? "Unpaid"
          : "";
      },
    },
  ];

  const VendorColumns = [
    {
      title: (
        <Tooltip title={t("Purchase Order")}>{t("Purchase Order")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "poName",
      key: "poName",
      render: (item, row) => {
        return (
          <Link
            to={"/purchaseOrderDetails"}
            state={{ POOrderID: row.poid, POOrderName: row.poName }}
          >
            <span className="linkText">{row.poName}</span>
          </Link>
        );
      },
    },
    {
      title: (
        <Tooltip title={t("Reference Number")}>{t("Reference Number")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "referenceNumber",
    },
    {
      title: <Tooltip title={t("Vendor Name")}>{t("Vendor Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "vendorName",
      width: "230px",
    },
    {
      title: <Tooltip title={t("Total items")}>{t("Total items")}</Tooltip>,
      ellipsis: true,
      dataIndex: "variation",
      key: "variation",
    },
    {
      title: <Tooltip title={t("Total Cost")}>{t("Total Cost")}</Tooltip>,
      ellipsis: true,
      dataIndex: "currencyPOTotal",
      render: (item, row) => {
        return <span>{row.currencyPOTotal}</span>;
      },
    },
    {
      title: <Tooltip title={t("Updated")}>{t("Updated")}</Tooltip>,
      ellipsis: true,
      dataIndex: "lastModifiedDate",
      key: "lastModifiedDate",
    },
    {
      title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
      ellipsis: true,
      dataIndex: "status",
      render: (item, row) => {
        return item == 2
          ? "Cancelled"
          : item == 1
          ? "Completed"
          : item == 0
          ? "Pending"
          : item == 3
          ? "Open"
          : item == 5
          ? "Unpaid"
          : item == 4
          ? "Shipped"
          : "";
      },
    },
  ];

  return (
    <div className="allprod_section">
      <div className="row">
        <div className="col-md-12">
          <div className="filter_section form__fields">
            <div className="form__fields">
              <div className="row magento__mapping">
                <div className="col-md-12">
                  <div className="heading__block">
                    <h4 className="workarea__heading mt-0 mb-0">
                      {t("Purchase Order")}
                    </h4>
                    <div
                      className="purchase-order-actions d-flex flex-wrap align-items-center justify-content-end mobile-justify-content-start w-40"
                      style={{ gap: "0.5rem" }}
                    >
                      <div className="purchase-order-search">
                        <div className="search__bar">
                          <Search
                            placeholder={t("Search")}
                            allowClear
                            onSearch={onSearch}
                            style={{
                              width: "100%",
                              maxWidth: 420,
                            }}
                          />
                        </div>
                      </div>
                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName == "Retailer" ||
                      vendorType == "" ? (
                        <Button
                          disabled={cancelOrderVisible}
                          className={
                            cancelOrederData.orderID == ""
                              ? "disabled-btn mr-2 purchase-order-btn"
                              : "primary-btn mr-2 purchase-order-btn"
                          }
                          onClick={() => {
                            setVisible(true);
                            handleCreatePoNo();
                          }}
                        >
                          {t("Reorder PO")}
                        </Button>
                      ) : null}

                      <Button
                        disabled={cancelOrederData.orderID == "" ? true : false}
                        className={
                          cancelOrederData.orderID == ""
                            ? "disabled-btn mr-2 purchase-order-btn view-order-btn"
                            : "primary-btn mr-2 purchase-order-btn view-order-btn"
                        }
                        onClick={() =>
                          navigate("/purchaseOrderDetails", {
                            state: {
                              POOrderID: cancelOrederData.orderID,
                              POOrderName: cancelOrederData.poName,
                              currencySign: cancelOrederData.currencySign,
                            },
                          })
                        }
                      >
                        {t("View Order")}
                      </Button>
                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName === "Retailer" ||
                      vendorType === "" ? (
                        <Button
                          disabled={
                            cancelOrederData.status === 2 ||
                            cancelOrederData.status === 1
                              ? true
                              : false
                          }
                          className={
                            cancelOrederData.orderID === "" ||
                            cancelOrederData.status === 2 ||
                            cancelOrederData.status === 1
                              ? "disabled-btn mr-2 purchase-order-btn"
                              : "primary-btn mr-2 purchase-order-btn"
                          }
                          onClick={handleCancelOrder}
                        >
                          {t("Cancel Order")}
                        </Button>
                      ) : (
                        <Button
                          disabled={
                            cancelOrederData.status === 2 ||
                            cancelOrederData.status === 1
                              ? true
                              : false
                          }
                          className={
                            cancelOrederData.status === 2 ||
                            cancelOrederData.status === 1
                              ? "disabled-btn mr-2 purchase-order-btn"
                              : "primary-btn mr-2 purchase-order-btn"
                          }
                          onClick={handleCancelOrder}
                        >
                          {t("Cancel Order")}
                        </Button>
                      )}

                      {
                        <Button
                          className={
                            props.type == "MergeProduct"
                              ? "primary-btn mb-3 purchase-order-btn"
                              : "primary-btn purchase-order-btn"
                          }
                          onClick={handleHideShowFilter}
                        >
                          <img src={Filter_icon} alt="" width="14px" />
                          {hideShowFilter ? (
                            <span>
                              {t("Filter")} <i className="fa fa-angle-up"></i>
                            </span>
                          ) : (
                            <span>
                              {t("Filter")} <i className="fa fa-angle-down"></i>
                            </span>
                          )}
                        </Button>
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-12 relative">
                  <div
                    style={{
                      height: 65,
                    }}
                    className={
                      hideShowFilter
                        ? " filter_inpsection mt-0 myMinHeightPO"
                        : " filter_inpsection hide myMinHeightPO"
                    }
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="input__block">
                            <label> {t("Vendor")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Vendor")}
                              optionFilterProp="children"
                              value={filterWatchValue.vendor || []}
                              onChange={(e) => onChangeDrop(e, "vendor")}
                            >
                              {vendorsList.length > 0 ? (
                                <Option> {t("All")} </Option>
                              ) : null}

                              {vendorsList &&
                                vendorsList.map((item) => {
                                  return (
                                    <Option
                                      value={item.vendorName}
                                      key={item.vendorNameID}
                                    >
                                      {item.vendorName}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="input__block">
                            <label> {t("Status")} </label>
                            <Select
                              className="border__grey"
                              placeholder={t("Selected")}
                              name="status"
                              value={filterWatchValue.status || []}
                              optionFilterProp="children"
                              onChange={(e) => onChangeDrop(e, "status")}
                            >
                              <Option value="3">{t("Open")}</Option>
                              <Option value="0">{t("Pending")}</Option>
                              <Option value="4">{t("Shipped")}</Option>
                              <Option value="5">{t("Unpaid")}</Option>
                              <Option value="1">{t("Completed")}</Option>
                              <Option value="2">{t("Cancelled")}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">

                        <div className="col-lg-12 col-md-12 filtbtn_div">
                          <button
                            className="primary-btn mr-2"
                            onClick={resetFilters}
                          >
                            {" "}
                            {t("Reset Filters")}{" "}
                          </button>
                          <button
                            className="primary-btn"
                            onClick={() =>
                              setFilterStatusorVendors(
                                selectedVendor,
                                selectedStatus
                              )
                            }
                          >
                            {" "}
                            {t("Apply Filters")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="divForm">
                  <Spin spinning={loading}>
                    <Table
                      columns={
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName == "Retailer" ||
                        vendorType == ""
                          ? RetailerColumns
                          : VendorColumns
                      }
                      dataSource={
                        statusFilter !== null
                          ? purchaseOrders.filter((item) => {
                              //console.log("item.vendor:", item.vendor, "| vendorFilter:", vendorFilter);
                              //console.log(item);
                              console.log(
                                "item.status:",
                                item.status,
                                "| statusFilter:",
                                statusFilter
                              );
                              // return item.status === statusFilter && item.vendorName === vendorFilter;
                              const statusMatch =
                                statusFilter === -1 || statusFilter === null
                                  ? true
                                  : Number(item.status) ===
                                    Number(statusFilter);

                              const vendorMatch = !vendorFilter
                                ? true
                                : item.vendorName === vendorFilter;

                              return statusMatch && vendorMatch;
                            })
                          : purchaseOrders
                      }
                      onRow={(record, recordIndex) => ({
                        onClick: (event) => {
                          setCancelOrederData({
                            orderID: record.poid,
                            poName: record.poName,
                            status: record.status,
                          });
                        },
                      })}
                      rowClassName={(record) =>
                        record.poid == cancelOrederData.orderID
                          ? "row-active-highlight"
                          : ""
                      }
                    />
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title={t("Reorder")}
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            {t("Generate PO")}
          </Button>,
        ]}
        width={400}
      >
        <div className="form__fields p-0 border-0">
          <div className="input__block">
            <label>{t("PO Name")}</label>
            <input
              type="text"
              name="PoName"
              value={reorderData.PoName}
              onChange={handleOnChange}
              className={validation.PONameVal && "border__red"}
              disabled
            />
            {validation.PONameVal && (
              <p className="error-color-red">{validation.PONameVal}</p>
            )}
          </div>
          <div className="input__block">
            <label>{t("Reference Number")}</label>
            <input
              type="text"
              name="referenceNumber"
              value={reorderData.referenceNumber}
              onChange={handleOnChange}
              className={validation.PONameVal && "border__red"}
            />
            {/* {validation.PONameVal && (
              <p className="error-color-red">{validation.PONameVal}</p>
            )} */}
          </div>

          <div className="input__block">
            <label>{t("Notes")}</label>
            <textarea
              name="notes"
              value={reorderData.notes}
              onChange={handleOnChange}
              className={validation.notesVal && "border__red"}
            ></textarea>
            {validation.notesVal && (
              <p className="error-color-red">{validation.notesVal}</p>
            )}
          </div>
        </div>
      </Modal>

      {/* Generate PO Modal */}

      <Modal
        title={t("Purchase Order Summary")}
        centered
        visible={generateOrderModalVisible}
        onOk={handleCreateReOrder}
        onCancel={handleCancel1}
        footer={[
          <Button key="back" onClick={handleCancel1}>
            {t("Cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleCreateReOrder}
            loading={submitLoading}
            disabled={dataToRender.length === 0}
          >
            {t("Submit PO")}
          </Button>,
        ]}
        width={1000}
      >
        <div className="form__fields">
          <Spin spinning={historyLoading}>
            <div className="row magento__mapping">
              <div className="col-md-4 mb-4">
                <h5 className="subheading">{t("Shipping Address")} :</h5>
                <p className="mb-0">
                  {purchaseOrdersDtRetailer.dealercompany
                    ? purchaseOrdersDtRetailer.dealercompany
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtRetailer.dealername
                    ? purchaseOrdersDtRetailer.dealername
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtRetailer.dealerAddress
                    ? purchaseOrdersDtRetailer.dealerAddress
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtRetailer.dealerCity
                    ? purchaseOrdersDtRetailer.dealerCity
                    : "null"}
                  ,{" "}
                  {purchaseOrdersDtRetailer.dealerState
                    ? purchaseOrdersDtRetailer.dealerState
                    : "null"}
                  ,
                  {purchaseOrdersDtRetailer.dealerZIP
                    ? purchaseOrdersDtRetailer.dealerZIP
                    : "null"}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtRetailer.dealerCountry
                    ? purchaseOrdersDtRetailer.dealerCountry
                    : ""}
                </p>
                <p className="mb-0">
                  {t("T")}:
                  {purchaseOrdersDtRetailer.dealerphone
                    ? purchaseOrdersDtRetailer.dealerphone
                    : ""}
                </p>
                <p className="mb-0">
                  {t("Email")}:{" "}
                  {purchaseOrdersDtRetailer.dealeremail
                    ? purchaseOrdersDtRetailer.dealeremail
                    : ""}
                </p>
              </div>

              <div className="col-md-4 mb-4">
                <h5 className="subheading">{t("Manufacturer Address")} :</h5>
                <p className="mb-0">
                  {purchaseOrdersDtVendor.dealercompany
                    ? purchaseOrdersDtVendor.dealercompany
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtVendor.dealername
                    ? purchaseOrdersDtVendor.dealername
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtVendor.dealerAddress
                    ? purchaseOrdersDtVendor.dealerAddress
                    : ""}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtVendor.dealerCity
                    ? purchaseOrdersDtVendor.dealerCity
                    : "null"}
                  ,{" "}
                  {purchaseOrdersDtVendor.dealerState
                    ? purchaseOrdersDtVendor.dealerState
                    : "null"}
                  ,
                  {purchaseOrdersDtVendor.dealerZIP
                    ? purchaseOrdersDtVendor.dealerZIP
                    : "null"}
                </p>
                <p className="mb-0">
                  {purchaseOrdersDtVendor.dealerCountry
                    ? purchaseOrdersDtVendor.dealerCountry
                    : ""}
                </p>
                <p className="mb-0">
                  {t("T")}:
                  {purchaseOrdersDtVendor.dealerphone
                    ? purchaseOrdersDtVendor.dealerphone
                    : ""}
                </p>
                <p className="mb-0">
                  {t("Email")}:{" "}
                  {purchaseOrdersDtVendor.dealeremail
                    ? purchaseOrdersDtVendor.dealeremail
                    : ""}
                </p>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="input__block">
                    <label> {t("Account Number")}: </label>
                    <input
                      type="text"
                      name="AccNo"
                      value={accNo}
                      className={error && "border__red"}
                      disabled
                    />
                    {error && (
                      <p className="error-color-red">
                        {t("Kindly Add Account Number First")}
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="input__block mb-3">
                    <label>
                      {t("Standard Carrier Alpha")} :{" "}
                      <span className="mandatory">*</span>
                    </label>{" "}
                    <Select
                      value={selectedSCA}
                      autocomplete="off"
                      name="SCAvalue"
                      showSearch
                      placeholder={t("Select SCA")}
                      onChange={(e) =>
                        handleSelectChange(e, "select", "SCAvalue")
                      }
                      className={
                        dataToRender.length === 0 || listerr
                          ? "border__red"
                          : "border__grey"
                      }
                    >
                      {dataToRender.map((item) => (
                        <Option key={item.scaid} value={item.scaid}>
                          {item.scacname}
                        </Option>
                      ))}
                    </Select>
                    {dataToRender.length === 0 && (
                      <p className="error-color-red">
                        {t(
                          "This vendor has not configured any SCA Codes. Please reach out to GemFind for assistance."
                        )}
                      </p>
                    )}
                    {listerr && (
                      <p className="error-color-red">
                        {t("Please Select Standard Carrier Alpha")}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <p>
                  {t("Order Notes")}:{" "}
                  {purchaseOrdersProductPrice.poName
                    ? purchaseOrdersProductPrice.poName
                    : ""}
                </p>
              </div>

              <div className="divForm">
                <Table
                  columns={[
                    {
                      title: <Tooltip title={t("Item")}>{t("Item")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "id",
                      key: "id",
                    },
                    {
                      title: (
                        <Tooltip title={t("Product Description")}>
                          {t("Product Description")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "productDesc",
                      key: "productDesc",
                    },
                    {
                      title: <Tooltip title={t("SKU")}>{t("SKU")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "retailerStockNumber",
                      key: "retailerStockNumber",
                    },
                    {
                      title: (
                        <Tooltip title={t("Vendor SKU")}>
                          {t("Vendor SKU")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "retailerStyle",
                      key: "retailerStyle",
                    },
                    {
                      title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "strPurchasePrice",
                      key: "strPurchasePrice",
                    },
                    {
                      title: <Tooltip title={t("Qty")}>{t("Qty")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "quantity",
                      key: "quantity",
                    },
                    {
                      title: (
                        <Tooltip title={t("SubTotal")}>{t("SubTotal")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "strEXTWholeSalePrice",
                      key: "strEXTWholeSalePrice",
                    },
                  ]}
                  dataSource={purchaseOrdersProductDetails}
                  pagination={false}
                />

                <div className="d-flex justify-content-end">
                  <div className="total__section p-3">
                    <p>
                      <span className="font__bold">{t("Total Item")}:</span>
                      {purchaseOrdersProductPrice.totalQuantity
                        ? purchaseOrdersProductPrice.totalQuantity
                        : 0}
                    </p>
                    <p>
                      <span className="font__bold">{t("SubTotal")}:</span>{" "}
                      {currencySign}
                      {purchaseOrdersProductPrice.currencyPOTotal
                        ? parseFloat(
                            purchaseOrdersProductPrice.currencyPOTotal
                          ).toFixed(2)
                        : "0.00"}
                    </p>
                    <p>
                      <span className="font__bold">{t("PO Total")}:</span>{" "}
                      {currencySign}
                      {purchaseOrdersProductPrice.currencyPOTotal
                        ? parseFloat(
                            purchaseOrdersProductPrice.currencyPOTotal
                          ).toFixed(2)
                        : "0.00"}
                    </p>
                  </div>
                </div>
                <p>{t("Vendor to provide shipping/insurance info.")}</p>
              </div>
            </div>
          </Spin>
        </div>
      </Modal>
      {/* End Modal */}

      {/* Cancel Order Modal */}
      <Modal
        className="delete_conv_modal"
        centered
        visible={cancelModalVisible}
        onCancel={handleCancelModal}
        width={400}
        footer={[
          <Button type="primary" onClick={handleUpdateOrderStatus}>
            {t("Cancel Order")}
          </Button>,
        ]}
      >
        <div className="col-lg-12">
          <div className="modal__body">
            <div className="col-lg-12">
              <div className="form__fields border-0 p-0">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <h5 className="reset-pass-conf-heading">
                      {t("Cancel The")} "{cancelOrederData.poName}" {t("Order")}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* End Cancel Order Modal */}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrder);
